import React, { createContext, useState, useContext } from 'react'
/**
 *  ===============================
 *      SAFETY CHECK CONTEXT
 *  ===============================
 */
const PopupContext = createContext(null)

export const ProvideSituationReport = ({ children }) => {
  const [isShowing, setIsShowing] = useState(false)
  const [countyId, setCountyId] = useState(null)

  return (
    <PopupContext.Provider value={[isShowing, setIsShowing, countyId, setCountyId]}>
      {
        children
      }
    </PopupContext.Provider>
  )
}

export const useSituationReport = () => useContext(PopupContext)
